import { API_VACANCY_URL } from '@/constants'
import { IVacancySearchParam } from '@/types'
import { IPaginationResponse } from '@/types/pagination'
import { IRequisition } from '@/types/requisition'
import { createAxiosInstance } from '@/utils'
const axios = createAxiosInstance({
  baseURL: API_VACANCY_URL,
  withAuth: true,
})

export interface IVacancyRequisitionSearchParam extends IVacancySearchParam {
  isRequisition: number
  flag?: string
}

export const fetchRequisition = (params?: IVacancyRequisitionSearchParam) => {
  const newParams: IVacancyRequisitionSearchParam = {
    ...params,
    isRequisition: 1,
    page: params?.page ?? 1,
    status: params?.status ?? 'active',
    sortedField: params?.sortedField ?? 'id',
    sortDirection: params?.sortDirection ?? 'DESC',
    flag: params?.flag ?? undefined,
  }
  return axios
    .get<{ data: IPaginationResponse<IRequisition> }>('/vacancy', {
      params: newParams,
    })
    .then((response) => response.data.data)
}
